import React from "react";
import "./ContactCardGroup.css";

function CardUserDepartName({ departName = "" }) {
  return (
    <React.Fragment>
      <div className="card-user-info">
        <div>{departName}</div>
      </div>
    </React.Fragment>
  );
}
function CardUserName({ name = "" }) {
  return (
    <React.Fragment>
      <div className="card-user-name">
        <div>{name}</div>
      </div>
    </React.Fragment>
  );
}
function ContactMobileInfo({ mobile = "" }) {
  const mobileParts = mobile.split(" ").join("");
  return (
    <React.Fragment>
      <a href={"tel:" + mobileParts} className="card-contact-info">
        {mobile}
      </a>
    </React.Fragment>
  );
}
function ContactEmailInfo({ email = "" }) {
  return (
    <React.Fragment>
      <a href={"mailto:" + email} className="card-contact-info">
        {email}
      </a>
    </React.Fragment>
  );
}

function Card({ name = "", departName = "", mobile = "", email = "" }) {
  return (
    <React.Fragment>
      <div className="contact-card">
        <CardUserDepartName departName={departName} />
        <CardUserName name={name} />
        <ContactMobileInfo mobile={mobile} />
        <ContactEmailInfo email={email} />
      </div>
    </React.Fragment>
  );
}

function ContactCardGroup({ contactsInfo = [] }) {
  return (
    <React.Fragment>
      <div className="contact-card-group">
        {contactsInfo.map((item, index) => (
          <Card
            key={index}
            name={item.name}
            departName={item.departName}
            mobile={item.mobile}
            email={item.email}
          />
        ))}
      </div>
    </React.Fragment>
  );
}

export default ContactCardGroup;
